isSourceAbs